import React, { useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { COMMON_API } from '../../CommonAPI';

const PortfolioProjectsPosition = () => {
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [projects, setProjects] = useState([]);

    // Fetch categories on mount
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const token = sessionStorage.getItem("authToken");
                const response = await axios.get(`${COMMON_API}/api/project/categories`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setCategories(response.data.categories);  // Correct way to set the categories
            } catch (error) {
                toast.error("Error fetching categories");
            }
        };
        fetchCategories();
    }, []);

    // Fetch projects when a category is selected
    const fetchProjectsByCategory = async (categoryId) => {
        try {
            const token = sessionStorage.getItem("authToken");
            const response = await axios.get(`${COMMON_API}/api/position/get-single-portfolio/${categoryId}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setProjects(response.data.projects); // assuming your controller sends { projects: [...] }
        } catch (error) {
            toast.error("Error fetching projects for category");
        }
    };

    // On dropdown change
    const handleCategoryChange = (e) => {
        const categoryId = e.target.value;
        setSelectedCategory(categoryId);
        if (categoryId) fetchProjectsByCategory(categoryId);
    };

    // Inline position change
    const handlePositionChange = (id, newPosition) => {
        setProjects(prev =>
            prev.map(proj =>
                proj.id === id ? { ...proj, position: newPosition } : proj
            )
        );
    };

    // Save updated position to backend
    const handleSave = async (id, position) => {
        try {
            const token = sessionStorage.getItem("authToken");
            await axios.put(`${COMMON_API}/api/position/update-project-position/${id}`, { position }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success("Position updated!");
        } catch (error) {
            toast.error("Error updating position");
        }
    };

    return (
        <div className="ml-64 p-8 bg-gray-100 min-h-screen">
            <h2 className="text-3xl font-semibold text-gray-800 mb-6">Portfolio Projects Position</h2>

            <div className="mb-6">
                <label className="block text-gray-700 mb-2">Select Category</label>
                <select
                    value={selectedCategory}
                    onChange={handleCategoryChange}
                    className="border px-3 py-2 rounded w-64"
                >
                    <option value="">-- Select Category --</option>
                    {categories.map(cat => (
                        <option key={cat.id} value={cat.id}>
                            {cat.category}
                        </option>
                    ))}
                </select>
            </div>

            {selectedCategory && (
                <div className="overflow-x-auto bg-white rounded shadow">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">S.No</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Project Name</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Position</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {projects.map((proj, index) => (
                                <tr key={proj.id}>
                                    <td className="px-6 py-4 whitespace-nowrap">{index + 1}</td>
                                    <td className="px-6 py-4">{proj.project_name}</td>
                                    <td className="px-6 py-4">
                                        <input
                                            type="number"
                                            className="border rounded px-2 py-1 w-20"
                                            value={proj.position}
                                            onChange={(e) => handlePositionChange(proj.id, e.target.value)}
                                        />
                                    </td>
                                    <td className="px-6 py-4">
                                        <button
                                            onClick={() => handleSave(proj.id, proj.position)}
                                            className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded"
                                        >
                                            Save
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {projects.length === 0 && (
                        <div className="p-4 text-center text-gray-500">No projects found for this category.</div>
                    )}
                </div>
            )}
        </div>
    );
};



export default PortfolioProjectsPosition;



